/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  branch Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  ADD_EXPENSE_DEFINITION(state, expenseDefinition) {
    state.expenseDefinitions.unshift(expenseDefinition);
    state.totalDataRow++;
  },
  SET_EXPENSE_DEFINITION(state, res) {
    state.expenseDefinitions = res.items
    state.totalDataRow = res.totalCount;
  },
  UPDATE_EXPENSE_DEFINITION(state, expenseDefinition) {
    const productIndex = state.expenseDefinitions.findIndex((p) => p.id == expenseDefinition.id)
    Object.assign(state.expenseDefinitions[productIndex], expenseDefinition)
  },
  REMOVE_EXPENSE_DEFINITION(state, expenseDefinitionId) {
    const expenseDefinitionIndex = state.expenseDefinitions.findIndex((p) => p.id == expenseDefinitionId)
    state.expenseDefinitions.splice(expenseDefinitionIndex, 1)
  },
}
